import {
  // Button,
  // Modal,
  // Form, 
  // Input,
  // Spin,
  // Image,
  // Upload,
  InputNumber
  // Checkbox,
  // message
} from 'antd';

import { useTranslation } from "react-i18next";
import { 
  useRef, 
  useState,
  // useEffect,
  forwardRef,
  useImperativeHandle
} from 'react';

import './printTemplateTwo.css';

interface PrintTemplateTwoProps {
  resultData: any
  chatData: any
  outerBorder?: boolean
  innerBorder?: boolean
}

const PrintTemplateTwo = ({ 
  resultData = {},
  chatData = {},
  outerBorder = false,
  innerBorder = false
}: PrintTemplateTwoProps, ref: any) => {
  const { t } = useTranslation();

  const paperRefs = useRef<any>([]);
  const [headerData, setHeaderData] = useState<any>({
    logo: '',
    textOne: '',
    textTwo: '',
  });

  const [footerData, setFooterData] = useState<any>({
    hrefWebsite: ''
  });

  const [dataList, setDataList] = useState<Array<any>>([]);

  const getRef = (el: any, index: number) => {
    paperRefs.current[index] = el;
  }

  const getFileName = () => {
    return t("exPdf.fileName");
  }

  /**
   *  type类型定义：
   *    1. img-cover: 通常用于图片独占一行
   *    2. only-title： 通常用于标题独占一行
   *    3. no-title: 用于不显示标题直接显示选项
   * 
   *  注释：子选项为 label和value独占一个td，所以一般一行中如果为四列为一行时，
   *       一个数组只需要放两个对象, 根据固定规则可实现表格展示
   *  
   *  字段说明：
   *    1. label: 字段名
   *    2. value: 字段值
   *    3. children: 子列表
   *    4. labelImage: 放在字段名的图片
   *    5. valueImage: 放在字段值的图片
   *    6. labelColSpan: 从字段名列开始合并多少列
   *    7. valueColSpan: 从字段值列开始合并多少列
   *    8. labelRowSpan：从字段名行开始合并多少行
   *    9. labelRowSpan：从字段值行开始合并多少行
   *    10. hideLabel: 不显示字段名那列
   *    11. hideValue: 不显示字段值那列
   *    其他字段根据情况添加（主要用于样式控制）
   * 
   */ 
  // 页面样式
  const pageStyleList = (data: any, itemIndex: number) => {
    const {
      type,
      label,
      value,
      labelColSpan,
      children,
      maxHeight: imgMaxHeight,
      tdHeight: itemTdHeight,
      labelFontWeight: itemLabelFontWeight,
      borderColor: itemBorderColor,
      backgroundColor: itemBackgroundColor,
      textAlign: itemTextAlign,
      labelFontSize: itemLabelFontSize
    } = data;

    const baseBorderColor = '#ababab';
    const baseBgColor = '#E5E5E5';

    if (type === 'img-cover') {
      return (
        <tr key={itemIndex + 'tr'}>
          <td 
            colSpan={4}
            style={{
              height: itemTdHeight || 'auto',
              borderColor: itemBorderColor || baseBorderColor,
            }}
          >
            {
              value ? <img
                alt=""
                style={{maxHeight: imgMaxHeight}}
                className="table-img" 
                src={value}
              /> : null
            }
          </td>
        </tr>
      );
    } else if (type === 'only-title' || type === 'only-title-contact') {
      return (
        <tr key={itemIndex + 'tr'}>
          <td 
            colSpan={labelColSpan}
            style={{
              backgroundColor: itemBackgroundColor || baseBgColor,
              textAlign: itemTextAlign || 'left',
              fontWeight: itemLabelFontWeight || 'normal',
              borderColor: itemBorderColor || baseBorderColor,
              fontSize: itemLabelFontSize || '15px',
            }}
          >
            { label } { type === 'only-title-contact' ? value : '' }
          </td>
        </tr>
      );
    } else if (type === 'html') {
      return (
        <tr key={itemIndex + 'tr'}>
          <td 
            colSpan={4}
            className='html-td'
            style={{
              backgroundColor: itemBackgroundColor || baseBgColor,
              textAlign: itemTextAlign || 'left',
              fontWeight: itemLabelFontWeight || 'normal',
              borderColor: itemBorderColor || baseBorderColor,
              fontSize: itemLabelFontSize || '15px',
            }}
            dangerouslySetInnerHTML={{
              __html: value
            }}
          >
          </td>
        </tr>
      );
    } else {
      return (
        <tr 
          key={itemIndex + 'tr'} 
          style={{ 
            backgroundColor: itemBackgroundColor || 'transparent' 
          }}
        >
          {
            children && children.map((item2: any, index2: number) => {
              return (
                <>
                  {
                    item2.hideLabel ? null : (<td
                      key={index2 + 'labeltd'}
                      colSpan={item2.labelColSpan || 1}
                      rowSpan={item2.labelRowSpan || 1}
                      style={{
                        color: item2.labelColor || 'black',
                        fontSize: item2.labelFontSize || '15px',
                        textAlign: item2.labelTextAlign || 'left',
                        fontWeight: item2.labelFontWeight || 'normal',
                        borderColor: itemBorderColor || baseBorderColor,
                      }}
                    >
                      { item2.label }
                      {
                        item2.labelImage ? <img
                          alt=""
                          className='label-img'
                          src={item2.labelImage} 
                        /> : null
                      }
                    </td>)
                  }
                  {
                    item2.hideValue ? null : (<td
                      key={index2 + 'valuetd'}
                      colSpan={item2.valueColSpan || 1}
                      rowSpan={item2.valueRowSpan || 1}
                      style={{
                        color: item2.valueColor || 'black',
                        fontSize: item2.valueFontSize || '15px',
                        textAlign: item2.valueTextAlign || 'left',
                        fontWeight: item2.valueFontWeight || 'normal',
                        borderColor: itemBorderColor || baseBorderColor,
                      }}
                    >
                      { item2.value }
                      {
                        item2.valueImage ? <img
                          alt=""
                          className='value-img'
                          src={item2.valueImage} 
                        /> : null
                      }
                    </td>)
                  }
                </>
              )
            })
          }
        </tr>
      );
    }
  }

  const initData = (printData: any) => {
    const {
      content = [],
      header = {},
      footer = {}
    } = printData;

    const {
      quantity,
      head,
      hmVal,
      effVal,
      powerVal,
      frequencyVal,
      speedVal,
      npshVal,
      chatBase64Data
    } = chatData;

    if (header) {
      const {
        logo,
        text = {}
      } = header;

      const headerItem = {
        logo: logo || '',
        textOne: text.one || '',
        textTwo: text.two || ''
      };

      const footerItem = {
        hrefWebsite: ''
      };

      setHeaderData(headerItem);
      setFooterData(footerItem);
    }

    if (footer) {
      const {
        href = {}
      } = footer;

      const footerItem = {
        hrefWebsite: href.website
      };
      
      setFooterData(footerItem);
    }

    let fieldItems: any = {
      'Rated Flow (m³/h)': quantity || '',
      'Rated Head (m)': head || '',
      'H Max(m)(Q=0)': hmVal,
      'Effiency at rated flow(%)': effVal,
      'Shaft power at rated flow(KW)': powerVal,
      'Frequency(HZ)': frequencyVal,
      'Operation Speed(RPM)': speedVal,
      'NPSHR at rated flow(m)': npshVal,
      'chatDataImg': chatBase64Data
    };

    const newDataList: Array<any> = [];

    content.forEach((itemList: any, index: number) => {
      let itemIndex = itemList.findIndex((child: any) => child.currentPageNoInnerBorder !== undefined);

      const item = {
        sort: index + 1,
        innerNoBorder: itemIndex !== -1,
        children: itemList
      };

      newDataList.push(item);
    })
    
    setDataList(forSetValue(newDataList, fieldItems));
  }

  const forSetValue = (array: Array<any>, fieldItems: any): Array<any> => {
    return array.map(node => {
      // 创建当前节点的浅拷贝
      const item = { ...node };
      
      if (item.label && fieldItems[item.label] !== undefined) {
        item.value = fieldItems[item.label];
      }
      
      // 递归处理子节点（如果有）
      if (node.children && node.children.length) {
        item.children = forSetValue(node.children, fieldItems);
      }
      
      return item;
    });
  }

  const handleSortEnter = (num: number, index: number) => {
    let list: Array<any> = [...dataList];
    
    list = list.sort((a: any, b: any) => {
      return a.sort  - b.sort;
    })

    setDataList(list);
  }

  const setDataListSort = (num: number, index: number) => {
    let list: Array<any> = [...dataList];
    list[index].sort = num;
    
    setDataList(list);
  }

  const setData = (data?: any) => {
    if (data) {
      initData(data);
    }
  }

  useImperativeHandle(ref, () => ({
    pageRefs: paperRefs.current,
    getFileName,
    setData
  }));

  return (
    <div className="page-template-two">
      {
        dataList.map((listItem: any, refIndex: number) => {
          return (
            <div className="pages-item" key={refIndex}>
              <div className="pages-item-number">
                { t("exPdf.sortNumber") }：
                <InputNumber 
                  min={1}
                  step={1}
                  value={listItem.sort}
                  onChange={(num: any) => setDataListSort(num, refIndex)}
                  onBlur={(e: any) => handleSortEnter(e, refIndex)}
                  onStep={(e: any) => handleSortEnter(e, refIndex)}
                />
              </div>
              <div 
                className='pages-content'
                ref={(e: any) => getRef(e, refIndex)}
              >
                <div className={`paper-table-content ${outerBorder ? 'outer-border' : ''} ${!listItem.innerNoBorder && innerBorder ? 'inner-border' : ''}`}>
                  <table className='paper-table'>
                    <thead>
                      <tr>
                        <th>
                          <img
                            alt=""
                            className="left-icon" 
                            src={headerData.logo}
                          />
                        </th>
                        <th colSpan={3}>
                          <h3 
                            className="right-title"
                            dangerouslySetInnerHTML={{
                              __html: headerData.textOne
                            }}
                          >
                          </h3>
                          <p className="right-desc">
                            { headerData.textTwo }
                          </p>
                          <p className="right-desc">
                            { footerData.hrefWebsite }
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        listItem.children && listItem.children.map((item: any, index: number) => pageStyleList(item, index))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default forwardRef(PrintTemplateTwo);
